import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { isClikArtCandidate } from '@/lib/panels/properties-panel-applicability'

/**
 * The placed ClikArt the Photo slot shows instead of a photo, or undefined when the slot holds a
 * photo or nothing. Same source rule as `resolveSelectedPhotoShape`: the live selection when the
 * slot is applicable, else the one unambiguous shape behind a read-only (mixed) selection.
 */
export function resolveSelectedClikArtShape(
  activeObject: ShapeData | null,
  photoSlotApplicable: boolean,
  readOnlyShape: ShapeData | null
): ShapeData | undefined {
  const source = photoSlotApplicable && activeObject ? activeObject : readOnlyShape

  return source && isClikArtCandidate(source) ? source : undefined
}
